const currentYear = new Date().getFullYear()

export const AR = {
  des_title: "الياسمين للأعمال الهندسية والتشطيبات والديكور",
  des:' تأسس مكتبنا استجابه للحاجة الملحوظه في سوق العمل للمهندسين ذوى الخبرة في مجال التصميم الداخلي والديكور ولذلك نحن متمسكون بأعلي معايير الاحتراف والصدق والتفاني في عملنا ونؤمن ان هذه القيم  تنعكس على تصميماتنا ذات الاسعار التنافسيه ',
  des2: "يلتزم مكتبنا بتزويد عملائنا بحلول تصميم داخلي مميزه مصممه خصيصا لتلبية احتياجاتهم وتفضيلاتهم الخاصة ",
  title: "الياسمين",
  links: [
    "الرئيسية",
    "من نحن",
    "البعض من مشاريعنا",
    "اعرف اكثر",
    "خدماتنا",
    "تواصل معنا",
  ],
  media: "وسائل التواصل",
  contact: "تواصل معنا",
  email: "company@Alyasmine.com",
  copyright:`  © حقوق النشر ${currentYear}. جميع الحقوق محفوظة. الياسمين `,
};

export const USA = {
  des_title: "Al-Yasmine for engineering, finishing and decoration works",
  des: " Our office was established in response to the noticeable need in the labor market for engineers with experience in the field of interior design and decoration. Therefore, we adhere to the highest standards of professionalism, honesty and dedication in our work, and we believe that these values ​​are reflected in our designs with competitive prices",
  des2: " Our office is committed to providing our clients with distinctive interior design solutions tailored to meet their specific needs and preferences",
  title: "Al-Yasmine",
  links: [
    "Home",
    "About Us",
    "Some of our projects",
    "Know More",
    "Services",
    "Contact Us",
  ],
  media: "Social media",
  contact: "Contact Us",
  email: "company@Alyasmine.com",
  copyright:`© Copyright ${currentYear}. All rights reserved. alyasmine`,
};
